import USERS_COUNT from "../graphql/UsersCount.graphql";
import { withContentCallback } from '@xem/entity/classes/preloadContents';

export default function userCount(name: string) {
	return withContentCallback(((res: any)=> res), name, USERS_COUNT)
}